/* eslint-disable no-restricted-syntax */
import layerService from '@/services/layer-service'
import { showLayer, hideLayer, setLayerOpacity } from '@/services/map-service'

/** Class responsible for handling layers */
export default class Layer {
  /**
   * @constructor
   */
  constructor(layerData, isSublayer, isBasemap, parentActive) {
    this.layerData = layerData
    this.isSublayer = isSublayer
    this.isBasemap = isBasemap
    this.parentActive = parentActive
    this.id = layerData.id
    this.name = layerData.name
    this.description = layerData.description
    this.drawOrder = layerData.draw_order || ''
    this.url = layerData.url || ''
    this.hasAccess = layerData.has_access
    this.minZoom = layerData.min_zoom
    this.maxZoom = layerData.max_zoom
    this.stylesheetID = layerData.stylesheet_layer_id || null
    this.active = this.layerData.show_by_default || false
    this.errorThrown = false
    this.opacity = null

    // Add to layer service
    layerService.addLayer(this)

    // Update the layer service active layers
    this.updateActiveLayers()
  }

  /**
   * Update the layer service active layers
   */
  updateActiveLayers() {
    this.active && this.parentActive
      ? layerService.addActiveLayer(this.id)
      : layerService.removeActiveLayer(this.id)
  }

  /**
   * Add the layer to the map
   */
  addToMap() {
    showLayer(this)
    this.active = true
    this.updateActiveLayers()
  }

  /**
   * Remove the layer from the map
   */
  removeFromMap() {
    hideLayer(this)
    this.active = false
    this.updateActiveLayers()
  }

  /**
   * Sets the opacity of the layer
   *
   * @param {float} Opacity between 0 and 1
   */
  setLayerOpacity(opacity) {
    this.opacity = opacity
    setLayerOpacity(this, opacity)
  }
}
